import { render, staticRenderFns } from "./BatchSearch.vue?vue&type=template&id=5fc98a98&scoped=true"
import script from "./BatchSearch.vue?vue&type=script&lang=js"
export * from "./BatchSearch.vue?vue&type=script&lang=js"
import style0 from "./BatchSearch.vue?vue&type=style&index=0&id=5fc98a98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc98a98",
  null
  
)

export default component.exports